// @flow
import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {defineMessages, FormattedMessage} from 'react-intl';
import {SVGIcon} from '@homeaway/react-svg';
import {TOOLTIP_INFO__16} from '@homeaway/svg-defs';
import {isDateless} from '../../utils/searchParamsUtils';

import type {State as ReduxState} from '../../reducers/index';

import '../DisclaimerMessaging/DisclaimerMessaging.less';

const messages = defineMessages({
    taxesAndFeesUSLine1: {
        id: 'taxesAndFeesUSLine1',
        defaultMessage: 'Additional fees apply.'
    },
    taxesAndFeesUSLine2: {
        id: 'taxesAndFeesUSLine2',
        defaultMessage: 'Taxes may be added.'
    },
    taxesAndFeesNonUSDateless: {
        id: 'taxesAndFeesNonUSDatelessLine2',
        defaultMessage: 'Additional taxes and fees may apply'
    }
});

type Props = {
    dated?: boolean,
    currency?: string,
    ariaHidden?: boolean
};

export const getLines = (dated?: boolean, currency?: string) => {
    // we can assume that if the default currency is USD, then it's a US brand
    if (currency === 'USD') {
        return [messages.taxesAndFeesUSLine1, messages.taxesAndFeesUSLine2];
    } else if (!dated) {
        return [messages.taxesAndFeesNonUSDateless];
    }
    return null;
};

export const DisclaimerMessaging = ({ariaHidden, dated, currency}: Props) => {
    const lines = getLines(dated, currency);

    if (!lines) {
        return false;
    }

    return (
        <div className="DisclaimerMessaging" aria-hidden={!!ariaHidden}>
            <SVGIcon
                markup={TOOLTIP_INFO__16}
                className="DisclaimerMessaging__icon"
                aria-hidden
            />
            <div className="DisclaimerMessaging__text">
                {lines.map((line) => (
                    <FormattedMessage key={line.id} {...line} />
                ))}
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState): Props => {
    let {
        searchParams: {params},
        system
    } = state;
    return {
        dated: !isDateless(params),
        currency: system.currency
    };
};

export default compose(connect(mapStateToProps))(DisclaimerMessaging);
